import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { OrderFormDetails } from "../../../models/order.interface";
import { IVisit } from "../../../models/study.interface";
import SelectFormInput from "../../Shared/SelectInput/SelectFormInput";

type VisitsSelectFormInputProps = {
  items: IVisit[];
  control: Control<OrderFormDetails, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
};

const VisitsSelectFormInput = ({
  items,
  isInvalid,
  disabled,
  control,
  required = false,
}: VisitsSelectFormInputProps) => {
  const intl = useIntl();

  const visitIdPlaceholder = intl.messages[
    "ORDERS.VISIT_ID.PLACEHOLDER"
  ] as string;

  return (
    <SelectFormInput
      name={"visitId"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: items.map((item) => ({ key: item.id, value: item.name })),
        placeholder: visitIdPlaceholder,
        isInvalid: isInvalid,
        disabled: disabled,
      }}
    />
  );
};

export default VisitsSelectFormInput;
